import { Input, Space } from 'antd';
import React, { FC, useState } from 'react';
import { InputStatus } from 'antd/es/_util/statusUtils';
import { EditOutlined } from '@ant-design/icons';

const NameEdit: FC<{
  showEditIcon?: boolean;
  onNameChange: (name: string) => boolean;
  defaultValue?: string;
  maxCount?: number;
}> = ({ onNameChange, defaultValue, showEditIcon, maxCount = 10 }) => {
  const [inputStatus, setInputStatus] = useState<InputStatus>();
  const [tips, setTips] = useState<string>();
  const [isEdit, setIsEdit] = useState(false);
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {isEdit ? (
        <Space>
          <Input
            status={inputStatus}
            maxLength={maxCount}
            showCount
            defaultValue={defaultValue}
            autoFocus
            onBlur={(e) => {
              const value = e.target.value;
              if (value) {
                const res = onNameChange(value);
                if (res) {
                  setTips(undefined);
                  setInputStatus(undefined);
                  setIsEdit(false);
                } else {
                  setInputStatus('error');
                  setTips('名称不能重复');
                }
              } else {
                setInputStatus('error');
                setTips('名称不能为空');
              }
            }}
          />
          {tips && <span className="text-red">{tips}</span>}
        </Space>
      ) : (
        defaultValue
      )}
      {showEditIcon && !isEdit && (
        <EditOutlined
          className="text-c0c0c0"
          onClick={(e) => {
            e.stopPropagation();
            setIsEdit(!isEdit);
          }}
        />
      )}
    </div>
  );
};
export default NameEdit;
